import auth0 from 'auth0-js';

let config;

if (process.env.NODE_ENV === 'production' && window.auth0Config) {
  config = window.auth0Config;

  // Auth0 is passing those parameters as strings, but WebAuth crashes if they are not integers.. Very sad.
  config.internalOptions = config.internalOptions || {};
  config.internalOptions.leeway = parseInt(config.internalOptions.leeway) || undefined;
  config.internalOptions.maxAge = parseInt(config.internalOptions.maxAge) || undefined;

  config = Object.assign(
    {
      overrides: {
        __tenant: config.auth0Tenant,
        __token_issuer: config.authorizationServer.issuer,
      },
      domain: config.auth0Domain,
      clientID: config.clientID,
      redirectUri: config.callbackURL,
      responseType: 'code',
    },
    config.internalOptions
  );
} else {
  config = {
    overrides: {
      __tenant: 'dev-29hrefs7',
      __token_issuer: 'https://login.oniudra.cc/',
    },
    domain: 'login.oniudra.cc',
    redirectUri: 'https://cdn.arduino.cc/header-footer/dev/',
    clientID: 'mJGEf7gQXid1V3kyzeDBTDRAZKC1hg3v',
    responseType: 'code',
  };
  // For debug purpose in local
  window.auth0Config = config;
}

const webAuth = new auth0.WebAuth(config);

const databaseConnection = 'arduino';

class AuthService {
  GOOGLE = 'google-oauth2';
  GITHUB = 'github';
  APPLE = 'apple';
  FACEBOOK = 'facebook';

  login(username, password, cb) {
    webAuth.login(
      {
        realm: databaseConnection,
        username,
        password,
      },
      (err) => cb(err)
    );
  }

  loginCoppa(username, password, cb) {
    const config = {
      realm: 'coppa',
      username,
      password,
    };
    webAuth.login(config, (err) => cb(err));
  }

  loginBrokenCoppa(username, password, cb) {
    webAuth.login(
      {
        realm: 'edu',
        username,
        password,
      },
      (err) => cb(err)
    );
  }

  loginWith(provider) {
    webAuth.authorize(
      {
        connection: provider,
      },
      function (err) {
        // eslint-disable-next-line
        if (err) console.log(err);
      }
    );
  }

  signupAndLogin(userParams, cb) {
    const params = { ...userParams, connection: databaseConnection };
    webAuth.redirect.signupAndLogin(params, (err) => cb(err));
  }

  signup(userParams, cb) {
    const params = { ...userParams, connection: databaseConnection };
    webAuth.signup(params, (err) => cb(err));
  }

  resetPasswordRequest(email, cb) {
    const params = { email, connection: databaseConnection };
    webAuth.changePassword(params, (err, resp) => cb(err, resp));
  }
}

const service = new AuthService();

export default service;
